import GfbRedirect from './gfb-redirect';

export default GfbRedirect;
